import { render, staticRenderFns } from "./subHeadPengelolaanK3L.vue?vue&type=template&id=fa9c9f4e&"
import script from "./subHeadPengelolaanK3L.vue?vue&type=script&lang=js&"
export * from "./subHeadPengelolaanK3L.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports